import * as Yup from 'yup';
import { handleTogglePasswordVisibility } from "./handleTogglePasswordVisibility.js";

let errors = {
    number: true,
    upper: true,
    lower: true,
    special: true,
    minLength: true,
    noCyrillic: true,
    noSpaces: true,
    repeat: true,
};

const minLengthSchema = Yup.string().min(10, 'Длина пароля должна быть не менее 10 символов');
const letterUpperSchema = Yup.string().matches(/[A-Z]/, 'Пароль должен содержать латинские символы верхнего регистра (A-Z)');
const letterLowerSchema = Yup.string().matches(/[a-z]/, 'Пароль должен содержать латинские символы нижнего регистра (a-z)');
const specialSchema = Yup.string().matches(
    /[,.<>/?;:'"[\]{}\\|`~!@#$%^&*()_+=-]/,
    'Пароль должен содержать знаки пунктуации (,.<>/?;:\'"[]{}\\|`~!@#$%^&*()_+=-)'
);
const numberSchema = Yup.string().matches(/\d/, 'Пароль должен содержать цифры (0-9).');

const repeatPasswordValid = Yup.string()
    .test('is-not-existing', 'Пароли не совпадают', function (value) {
        const { mewPass } = this.options.context;
        return value === mewPass;
    });

export const initValidPassword = () => {
    const modal = document.getElementById("profile-update-password");
    if (!modal) return;

    const togglePasswordVisibilityButtons = modal.querySelectorAll('.js-visible-password');
    const OK = modal.querySelector('.js-password-OK');
    const btn = modal.querySelector('.js-btn');
    const newPasswordTextfield = modal.querySelector('.js-new-password-textfield');
    const newPassword = newPasswordTextfield.querySelector('[new-password]');
    const repeatPasswordTextfield = modal.querySelector('.js-repeat-password-textfield');
    const repeatPassword = repeatPasswordTextfield.querySelector('[repeat-password]');
    const list = modal.querySelector('.js-profile-validation');

    const upper = list.querySelector('.js-valid-upper');
    const lower = list.querySelector('.js-valid-lower');
    const special = list.querySelector('.js-valid-special');
    const minLength = list.querySelector('.js-valid-minLength');
    const number = list.querySelector('.js-valid-number');
    const noCyrillic = list.querySelector('.js-valid-no-cyrillic');
    const noSpaces = list.querySelector('.js-valid-no-spaces');

    function setRuleState(element, isValid, isTouched) {
        if (!element) return;

        if (!isTouched) {
            element.classList.remove('valid-success');
            element.classList.remove('valid-error');
            return;
        }

        if (isValid) {
            element.classList.remove('valid-error');
            element.classList.add('valid-success');
        } else {
            element.classList.remove('valid-success');
            element.classList.add('valid-error');
        }
    }

    function hasCyrillic(value) {
        return /[\u0400-\u04FF]/.test(value);
    }
    function hasSpaces(value) {
        return !/^\S+$/.test(value);
    }

    async function validatePasswordValue(mewPass) {
        const isTouched = mewPass.length > 0;

        try {
            await numberSchema.validate(mewPass);
            errors.number = false;
            setRuleState(number, true, isTouched);
        } catch {
            errors.number = true;
            setRuleState(number, false, isTouched);
        }

        try {
            await letterUpperSchema.validate(mewPass);
            errors.upper = false;
            setRuleState(upper, true, isTouched);
        } catch {
            errors.upper = true;
            setRuleState(upper, false, isTouched);
        }

        try {
            await letterLowerSchema.validate(mewPass);
            errors.lower = false;
            setRuleState(lower, true, isTouched);
        } catch {
            errors.lower = true;
            setRuleState(lower, false, isTouched);
        }

        try {
            await specialSchema.validate(mewPass);
            errors.special = false;
            setRuleState(special, true, isTouched);
        } catch {
            errors.special = true;
            setRuleState(special, false, isTouched);
        }

        try {
            await minLengthSchema.validate(mewPass);
            errors.minLength = false;
            setRuleState(minLength, true, isTouched);
        } catch {
            errors.minLength = true;
            setRuleState(minLength, false, isTouched);
        }

        const noCyrillicValid = !hasCyrillic(mewPass);
        const noSpacesValid = !hasSpaces(mewPass);
        
        errors.noCyrillic = !noCyrillicValid;
        setRuleState(noCyrillic, noCyrillicValid, isTouched);
        
        errors.noSpaces = !noSpacesValid;
        setRuleState(noSpaces, noSpacesValid, isTouched);

        if (!isTouched) {
            newPasswordTextfield.removeAttribute("data-error");
            return;
        }

        if (!noSpacesValid) {
            newPasswordTextfield.setAttribute("data-error", "Пароль не должен содержать пробелы");
            return;
        }

        if (!noCyrillicValid) {
            newPasswordTextfield.setAttribute("data-error", "Пароль не должен содержать кириллицу");
            return;
        }

        if (
            errors.number ||
            errors.upper ||
            errors.lower ||
            errors.special ||
            errors.minLength
        ) {
            newPasswordTextfield.setAttribute("data-error", " ");
            return;
        }

        newPasswordTextfield.removeAttribute("data-error");
    }

    async function validateRepeatValue(repeatPass, mewPass) {
        if (!repeatPass.length) {
            errors.repeat = true;
            repeatPasswordTextfield.removeAttribute("data-error");
            return;
        }

        try {
            await repeatPasswordValid.validate(repeatPass, { context: { mewPass } });
            errors.repeat = false;
            repeatPasswordTextfield.removeAttribute("data-error");

            if (
                !errors.number &&
                !errors.upper &&
                !errors.lower &&
                !errors.special &&
                !errors.minLength &&
                !errors.noCyrillic &&
                !errors.noSpaces
            ) {
                newPasswordTextfield.removeAttribute("data-error");
            }
        } catch (error) {
            errors.repeat = true;
            repeatPasswordTextfield.setAttribute("data-error", error.message);
            newPasswordTextfield.setAttribute("data-error", " ");
        }
    }

    newPassword.addEventListener("input", async function (e) {
        let mewPass = e.target.value;
        let repeatPass = repeatPassword.value;

        await validatePasswordValue(mewPass);
        await validateRepeatValue(repeatPass, mewPass);
    });

    repeatPassword.addEventListener("input", async function (e) {
        let repeatPass = e.target.value;
        let mewPass = newPassword.value;

        await validateRepeatValue(repeatPass, mewPass);
    });

    togglePasswordVisibilityButtons.forEach(button => {
        button.addEventListener('click', () => handleTogglePasswordVisibility(button));
    });

    btn.addEventListener("click", async function () {
        const mewPass = newPassword.value;
        const repeatPass = repeatPassword.value;

        await validatePasswordValue(mewPass);
        await validateRepeatValue(repeatPass, mewPass);

        const hasError = Object.values(errors).some(value => value === true);

        if (!hasError) {
            OK.click();
            newPassword.value = '';
            repeatPassword.value = '';

            Object.keys(errors).forEach((key) => {
                errors[key] = true;
            });

            [minLength, upper, lower, number, special, noCyrillic, noSpaces].forEach((item) => {
                if (!item) return;
                item.classList.remove('valid-success');
                item.classList.remove('valid-error');
            });

            newPasswordTextfield.removeAttribute("data-error");
            repeatPasswordTextfield.removeAttribute("data-error");
        }
    });
};